module.exports = __webpack_public_path__ + "static/media/crypto-copyright.f8a1583c.png";